type Props = {
  children: React.ReactNode;
};

export function Sidebar({ children }: Props) {
  return <aside className="h-full flex flex-col">{children}</aside>;
}
